import React from 'react';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const TaglineConfigurator = ({ 
  showTagline, 
  taglineText, 
  onShowTaglineChange, 
  onTaglineTextChange 
}) => {
  const maxLength = 60;
  const remainingChars = maxLength - taglineText?.length;

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-foreground">Tagline-Konfiguration</h3>
      {/* Show/Hide Toggle */}
      <div className="space-y-3">
        <Checkbox
          label="Tagline anzeigen"
          description="Zeigt eine kurze Beschreibung unter dem Chat-Header an"
          checked={showTagline}
          onChange={(e) => onShowTaglineChange(e?.target?.checked)}
        />
      </div>
      {/* Tagline Text Input */}
      {showTagline && (
        <div className="space-y-3">
          <Input
            label="Tagline-Text"
            type="text"
            value={taglineText}
            onChange={(e) => onTaglineTextChange(e?.target?.value)}
            placeholder="z.B. Wir sind hier, um Ihnen zu helfen!"
            maxLength={maxLength}
            description={`${remainingChars} Zeichen verbleibend`}
            error={remainingChars < 0 ? 'Text ist zu lang' : ''}
          />
          
          {/* Character Counter */}
          <div className="flex justify-between items-center text-xs">
            <span className="text-muted-foreground">
              Empfohlen: 20-40 Zeichen für beste Lesbarkeit
            </span>
            <span className={`font-mono ${remainingChars < 10 ? 'text-warning' : remainingChars < 0 ? 'text-error' : 'text-muted-foreground'}`}>
              {taglineText?.length}/{maxLength}
            </span>
          </div>
        </div>
      )}
      {/* Tagline Examples */}
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-foreground">Beispiele für gute Taglines:</h4>
        <div className="grid gap-2">
          {[
            "Wir sind hier, um Ihnen zu helfen!",
            "Schnelle Antworten auf Ihre Fragen",
            "24/7 Support für Sie da",
            "Ihr persönlicher Assistent",
            "Fragen? Wir haben die Antworten!"
          ]?.map((example, index) => (
            <button
              key={index}
              onClick={() => onTaglineTextChange(example)}
              className="text-left p-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded border border-transparent hover:border-border transition-all duration-200"
              disabled={!showTagline}
            >
              "{example}"
            </button>
          ))}
        </div>
      </div>
      {/* Preview */}
      <div className="p-4 bg-muted rounded-lg">
        <p className="text-xs font-medium text-muted-foreground mb-3">Tagline-Vorschau</p>
        
        <div className="bg-card border border-border rounded-lg overflow-hidden max-w-sm">
          {/* Chat Header */}
          <div className="bg-primary text-primary-foreground px-4 py-3">
            <h6 className="font-medium">Chat-Support</h6>
            {showTagline && taglineText && (
              <p className="text-sm opacity-90 mt-1">
                {taglineText}
              </p>
            )}
          </div>
          
          {/* Chat Content Preview */}
          <div className="p-4">
            <div className="bg-muted rounded-lg px-3 py-2">
              <p className="text-sm text-muted-foreground">
                Hallo! Wie kann ich Ihnen helfen?
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Tips */}
      <div className="p-3 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-2">
          <div className="w-4 h-4 rounded-full bg-accent flex-shrink-0 mt-0.5"></div>
          <div>
            <p className="text-sm font-medium text-accent-foreground">Tipps für effektive Taglines</p>
            <ul className="text-xs text-accent-foreground/80 mt-1 space-y-1">
              <li>• Halten Sie es kurz und prägnant (20-40 Zeichen)</li>
              <li>• Verwenden Sie eine freundliche, einladende Sprache</li>
              <li>• Vermeiden Sie Fachjargon oder komplexe Begriffe</li>
              <li>• Betonen Sie Ihre Verfügbarkeit und Hilfsbereitschaft</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaglineConfigurator;